export default "__VITE_ASSET__6b7419d2__"